// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"a2a72eae","444":"3badbd20","453":"926f0775","955":"63f3c46c"}[chunkId] + ".chunk.js";
};